import { useState, useEffect, useRef } from 'react';

import { getOrientation, Orientation } from '@ezugi/utils/src/helpers/getOrientation';

export function useOrientationChange(): Orientation {
  const [ orientation, setOrientation ] = useState<Orientation>(getOrientation());
  const ref = useRef(getOrientation());

  useEffect(() => {
    function update() {
      const next = getOrientation();

      if (next !== ref.current) {
        ref.current = next;
        setOrientation(next);
      }
    }
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('resize', update);
    };
  }, []);

  return orientation;
}
